import { useEffect } from "react";

const DisableSwipeBack: React.FC = () => {
  useEffect(() => {
    // Disable browser's default back navigation
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const disableBackNavigation = (event: Event) => {
      event.preventDefault();

      return false;
    };

    // Prevent default touch actions
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const preventTouchMove = (event: TouchEvent) => {
      event.preventDefault();
    };

    // Modify CSS to prevent swipe gestures
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      html, body {
        overscroll-behavior-x: none !important;
        touch-action: pan-y !important;
      }
    `;
    document.head.appendChild(styleElement);

    // Add event listeners
    window.addEventListener("touchmove", preventTouchMove, { passive: false });

    // Optional: Handle browser back button
    window.addEventListener("popstate", disableBackNavigation, {
      passive: false,
    });

    // Cleanup function
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => {
      window.removeEventListener("touchmove", preventTouchMove);
      window.removeEventListener("popstate", disableBackNavigation);
      document.head.removeChild(styleElement);
    };
  }, []);

  return null;
};

export default DisableSwipeBack;
